import { render, staticRenderFns } from "./SetupStudentModules.vue?vue&type=template&id=56e04c3b"
import script from "./SetupStudentModules.vue?vue&type=script&lang=js"
export * from "./SetupStudentModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports